import React from 'react';
import { CommentFilterType } from '~/containers/Comments/Comments';
import { Building } from '~/types/building';
import { GatheringType } from '~/types/gathering';
import CommentSectionFilter from '../CommentSectionFilter/CommentSectionFilter';
import { GroupType } from '~/types/group';
import moment from 'moment';

interface IProps {
  selectedBuilding?: Building;
  upcomingGatherings: GatheringType[];
  pastGatherings: GatheringType[];
  selectedGatheringId: string;
  gatheringDate?: string;
  selectedGroupId: string;
  selectFilter: (
    type: CommentFilterType,
    gatheringId: string,
    interestedDate?: string
  ) => void;
  showGatherings: boolean;
  handleGatheringFilterClick: () => void;
  showGroups: boolean;
  handleGroupFilterClick: () => void;
  groups: GroupType[];
  selectedPlaceCategory: string;
  showPlaces: boolean;
  handlePlaceFilterClick: () => void;
  placeCategories: { uuid: string; name: string; countComments: number }[];
  selectedListingCategory: string;
  showListings: boolean;
  handleListingFilterClick: () => void;
  /** Empty unless the building is on Marketplace v2 — then the section hides. */
  listingCategories: { uuid: string; name: string; countComments: number }[];
}
const CommentSectionFilters = (props: IProps) => {
  const {
    selectedBuilding,
    upcomingGatherings,
    pastGatherings,
    selectedGatheringId,
    gatheringDate,
    selectedGroupId,
    selectFilter,
    showGatherings,
    handleGatheringFilterClick,
    showGroups,
    handleGroupFilterClick,
    groups,
    selectedPlaceCategory,
    showPlaces,
    handlePlaceFilterClick,
    placeCategories,
    selectedListingCategory,
    showListings,
    handleListingFilterClick,
    listingCategories
  } = props;

  return (
    <div>
      <CommentSectionFilter
        selectedFilter={selectedGatheringId}
        onClickAction={() => {
          selectFilter(CommentFilterType.BUILDING, '');
        }}
        filters={[
          {
            uuid: selectedBuilding?.uuid ?? '',
            image: selectedBuilding?.image ?? '',
            title: selectedBuilding?.name ?? ''
          }
        ]}
        sectionTitle='BUILDING CHAT'
        isBuildingChat
        isBuildingChatSelected={!selectedGatheringId && !selectedGroupId}
      />
      {upcomingGatherings.length > 0 && (
        <CommentSectionFilter
          selectedFilter={`${selectedGatheringId}${
            gatheringDate ? `?${gatheringDate}` : ''
          }`}
          onClickAction={(id: string, gathering: GatheringType) =>
            selectFilter(
              CommentFilterType.GATHERING,
              id,
              gathering?.isRecurring
                ? moment(gathering.scheduledStartTime)
                    .tz(gathering.buildingTimezone)
                    .format('YYYY-MM-DD')
                : ''
            )
          }
          filters={upcomingGatherings}
          showFilters={showGatherings}
          openFilterOptions={handleGatheringFilterClick}
          sectionTitle='UPCOMING GATHERINGS (MAX 20)'
          isBuildingChatSelected={false}
        />
      )}
      {pastGatherings.length > 0 && (
        <CommentSectionFilter
          selectedFilter={`${selectedGatheringId}${
            gatheringDate ? `?${gatheringDate}` : ''
          }`}
          onClickAction={(id: string, gathering: GatheringType) =>
            selectFilter(
              CommentFilterType.GATHERING,
              id,
              gathering?.isRecurring
                ? moment(gathering.scheduledStartTime)
                    .tz(gathering.buildingTimezone)
                    .format('YYYY-MM-DD')
                : ''
            )
          }
          filters={pastGatherings}
          showFilters={showGatherings}
          openFilterOptions={handleGatheringFilterClick}
          sectionTitle='PAST GATHERINGS (LAST 3 MONTH)'
          isBuildingChatSelected={false}
        />
      )}
      {groups.length > 0 && (
        <CommentSectionFilter
          selectedFilter={selectedGroupId}
          onClickAction={(id: string) =>
            selectFilter(CommentFilterType.GROUP, id)
          }
          filters={groups}
          showFilters={showGroups}
          openFilterOptions={handleGroupFilterClick}
          sectionTitle='GROUPS'
          isBuildingChatSelected={false}
        />
      )}
      {placeCategories.length > 0 && (
        <CommentSectionFilter
          selectedFilter={selectedPlaceCategory}
          onClickAction={(id: string) =>
            selectFilter(CommentFilterType.PLACE, id)
          }
          filters={placeCategories}
          showFilters={showPlaces}
          openFilterOptions={handlePlaceFilterClick}
          sectionTitle='PLACES'
          isBuildingChatSelected={false}
        />
      )}
      {listingCategories.length > 0 && (
        <CommentSectionFilter
          selectedFilter={selectedListingCategory}
          onClickAction={(id: string) =>
            selectFilter(CommentFilterType.LISTING, id)
          }
          filters={listingCategories}
          showFilters={showListings}
          openFilterOptions={handleListingFilterClick}
          sectionTitle='MARKETPLACE'
          isBuildingChatSelected={false}
        />
      )}
    </div>
  );
};

export default CommentSectionFilters;
